import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Container, Card, Button, OverlayTrigger, Tooltip, Spinner } from 'react-bootstrap'

import { FreeMode, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css'
import 'swiper/css/pagination'
import './../pagination_fix.sass'

import styles from './../blocks.module.sass'

export default class Main extends Component {

  constructor(props) {
    super(props)

    this.state = {
      products: null,
      page: 1,
      count: 0
    }
  }

  priceFormat(price, delimiter, fraction) {
    fraction = [0,1,2].indexOf(fraction) !== -1 ? fraction : 0
    delimiter = delimiter || ' '
    price = (price = parseFloat(price)) && isFinite(price) && price.toFixed(fraction) || false
    if (price === false) throw new TypeError('Price should be a valid integer.')
    var reverseString = function(string) {
        return string.split('').reverse().join('')
    }
    return reverseString(reverseString(price).replace(/(\d{3})/g, '$&' + delimiter))
  }

  inCart = ( id ) => {
    const { cart } = this.props
    var fined = false
    cart.map(( celm ) => {
      if( celm.resource == id ) {
        fined = true
      }
    })
    return fined
  }

  render() {

    const { link, title, showInCart, favorite, changeFavorite, in_cart_loading, products } = this.props

    if(products != null) return (
      <div className={styles.recomendedng}>
        <Container>
          <div className='w-100 d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-end'>
            <div className={styles.recomendedng_title}>{title}</div>
            <a href={link} className={styles.recomendedng_all}>Смотреть все →</a>
          </div>
          <div className='d-none d-lg-block'>
            <Swiper
              modules={[FreeMode, Pagination]}
              pagination={{ type: `progressbar` }}
              spaceBetween={6}
              slidesPerView={`auto`}
              freeMode={true}
              className={styles.recomendedng_slyder_prod}
              speed={300}
            >
              {products.map(( elm, i ) => {
                return (
                  <SwiperSlide key={i} className={styles.recomendedng_catalog_card_w_slyder}>
                    <Card className={styles.recomendedng_catalog_card_slyder}>
                      <Card.Img alt={elm.name} className={styles.recomendedng_catalog_card_image} variant="top" src={elm.image} width="259" height="362" />
                      <Card.Body className={styles.recomendedng_catalog_card_content}>
                        <div className={styles.recomendedng_catalog_card_art}>Арт. {elm.article}</div>
                        <a href={elm.url} className={styles.recomendedng_catalog_card_name + ` text-truncate stretched-link`}>{elm.name}</a>
                        <div className='d-flex align-items-center justify-content-between'>
                          <div className='d-flex align-items-center justify-content-start'>
                            {elm.price > 0 &&
                              <div className={styles.recomendedng_catalog_card_price}>
                                {elm?.old_price > elm.price ? (
                                  <>
                                    <s>{this.priceFormat(elm.old_price)}</s>{` `}
                                    <font color='red'>{this.priceFormat(elm.price)}</font>{` `}
                                  </>
                                ) : (
                                  <>{this.priceFormat(elm.price)}{` `}</>
                                )}
                                <span>₽</span>
                              </div>
                            }
                            <div className={styles.recomendedng_catalog_card_dot}></div>
                            {elm.color != '' &&
                              <OverlayTrigger overlay={<Tooltip id={`color_overlay_m_` + elm.id + `_` + i}>{elm.colorName}</Tooltip>}>
                                <div style={{ backgroundColor: elm.color }} className={styles.recomendedng_catalog_card_color}></div>
                              </OverlayTrigger>
                            }
                          </div>
                          <div className='d-flex align-items-center justify-content-end'>
                            <Button onClick={() => changeFavorite( elm.id )} className={styles.recomendedng_catalog_card_btn} variant={ favorite.includes( elm.id ) ? `danger` : `primary`}>
                              <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.02051 4.26339V13.4091C1.02051 14.7214 1.02051 15.3774 1.21732 15.779C1.58211 16.5232 2.38156 16.951 3.20316 16.8417C3.64643 16.7827 4.1924 16.4187 5.28433 15.6908L5.28695 15.689C5.71975 15.4005 5.93618 15.2562 6.16258 15.1762C6.5784 15.0292 7.03211 15.0292 7.44793 15.1762C7.67478 15.2563 7.89206 15.4012 8.32661 15.6909C9.41854 16.4189 9.96512 16.7825 10.4084 16.8415C11.23 16.9508 12.0294 16.5232 12.3942 15.779C12.591 15.3775 12.591 14.7212 12.591 13.4091V4.26022C12.591 3.18232 12.591 2.64256 12.381 2.23045C12.1961 1.8676 11.9004 1.5728 11.5375 1.38792C11.125 1.17773 10.5857 1.17773 9.50572 1.17773H4.10616C3.02615 1.17773 2.48574 1.17773 2.07323 1.38792C1.71037 1.5728 1.41558 1.8676 1.23069 2.23045C1.02051 2.64296 1.02051 3.18337 1.02051 4.26339Z" stroke="white" strokeWidth="0.964208" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                            </Button>
                            {in_cart_loading ?
                              <Button className={styles.recomendedng_catalog_card_btn} variant="primary">
                                <Spinner style={{ width: `20px`, height: `20px` }} animation="border" variant="light" />
                              </Button>
                            :
                              <Button onClick={() => showInCart( elm.id )} className={styles.recomendedng_catalog_card_btn} variant={ this.inCart( elm.res_id ) ? `danger` : `primary`}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M14.9129 15.4305C13.8035 15.4305 12.9042 16.3299 12.9042 17.4393C12.9042 18.5487 13.8035 19.448 14.9129 19.448C16.0223 19.448 16.9217 18.5487 16.9217 17.4393C16.9217 16.3299 16.0223 15.4305 14.9129 15.4305ZM14.9129 15.4305H7.17309C6.71001 15.4305 6.47805 15.4305 6.28739 15.3481C6.11921 15.2754 5.9733 15.1584 5.86699 15.0092C5.74783 14.8419 5.69991 14.6183 5.60505 14.1755L3.133 2.63933C3.03593 2.18634 2.98675 1.9601 2.86621 1.7909C2.75991 1.64168 2.61402 1.52423 2.44584 1.45155C2.25514 1.36914 2.02447 1.36914 1.56119 1.36914H0.851562M3.86471 4.38229H16.7944C17.5193 4.38229 17.8814 4.38229 18.1247 4.53331C18.3378 4.66559 18.4939 4.87305 18.5619 5.11449C18.6396 5.39012 18.5398 5.73817 18.3389 6.4347L16.9482 11.2557C16.828 11.6722 16.7679 11.88 16.6461 12.0346C16.5385 12.171 16.3966 12.2777 16.2357 12.3433C16.054 12.4174 15.8381 12.4174 15.4072 12.4174H5.60276M5.87348 19.448C4.76407 19.448 3.86471 18.5487 3.86471 17.4393C3.86471 16.3299 4.76407 15.4305 5.87348 15.4305C6.98289 15.4305 7.88224 16.3299 7.88224 17.4393C7.88224 18.5487 6.98289 19.448 5.87348 19.448Z" stroke="white" strokeWidth="0.964208" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                              </Button>
                            }
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </SwiperSlide>
                )
              })}
              <SwiperSlide className={styles.recomendedng_catalog_card_w_last + ` d-lg-none`}></SwiperSlide>
            </Swiper>
          </div>
          <Swiper
            modules={[FreeMode, Pagination]}
            pagination={{ type: `progressbar` }}
            spaceBetween={6}
            slidesPerView={`auto`}
            freeMode={true}
            className={styles.recomendedng_slyder + ` d-lg-none`}
            speed={300}
          >
            {products.map(( elm, i ) => {
              return (
                <SwiperSlide key={i} className={styles.recomendedng_catalog_card_w}>
                  <Card className={styles.recomendedng_catalog_card}>
                    <Card.Img alt={elm.name} className={styles.recomendedng_catalog_card_image} variant="top" src={elm.image} width="259" height="362" />
                    <Card.Body className={styles.recomendedng_catalog_card_content}>
                      <div className={styles.recomendedng_catalog_card_art}>Арт. {elm.article}</div>
                      <a href={elm.url} className={styles.recomendedng_catalog_card_name + ` text-truncate stretched-link`}>{elm.name}</a>
                      <div className='d-flex align-items-center justify-content-between'>
                        <div className='d-flex align-items-center justify-content-start'>
                          {elm.price > 0 &&
                            <div className={styles.recomendedng_catalog_card_price}>
                              {elm?.old_price > elm.price ? (
                                <>
                                  <s>{this.priceFormat(elm.old_price)}</s>{` `}
                                  <font color='red'>{this.priceFormat(elm.price)}</font>{` `}
                                </>
                              ) : (
                                <>{this.priceFormat(elm.price)}{` `}</>
                              )}
                              <span>₽</span>
                            </div>
                          }
                          <div className={styles.recomendedng_catalog_card_dot}></div>
                          {elm.color != '' &&
                            <OverlayTrigger overlay={<Tooltip id={`color_overlay_m_` + elm.id + `_` + i}>{elm.colorName}</Tooltip>}>
                              <div style={{ backgroundColor: elm.color }} className={styles.recomendedng_catalog_card_color}></div>
                            </OverlayTrigger>
                          }
                        </div>
                        <div className='d-flex align-items-center justify-content-end'>
                          <Button onClick={() => changeFavorite( elm.id )} className={styles.recomendedng_catalog_card_btn} variant={ favorite.includes( elm.id ) ? `danger` : `primary`}>
                            <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1.02051 4.26339V13.4091C1.02051 14.7214 1.02051 15.3774 1.21732 15.779C1.58211 16.5232 2.38156 16.951 3.20316 16.8417C3.64643 16.7827 4.1924 16.4187 5.28433 15.6908L5.28695 15.689C5.71975 15.4005 5.93618 15.2562 6.16258 15.1762C6.5784 15.0292 7.03211 15.0292 7.44793 15.1762C7.67478 15.2563 7.89206 15.4012 8.32661 15.6909C9.41854 16.4189 9.96512 16.7825 10.4084 16.8415C11.23 16.9508 12.0294 16.5232 12.3942 15.779C12.591 15.3775 12.591 14.7212 12.591 13.4091V4.26022C12.591 3.18232 12.591 2.64256 12.381 2.23045C12.1961 1.8676 11.9004 1.5728 11.5375 1.38792C11.125 1.17773 10.5857 1.17773 9.50572 1.17773H4.10616C3.02615 1.17773 2.48574 1.17773 2.07323 1.38792C1.71037 1.5728 1.41558 1.8676 1.23069 2.23045C1.02051 2.64296 1.02051 3.18337 1.02051 4.26339Z" stroke="white" strokeWidth="0.964208" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </Button>
                          {in_cart_loading ?
                            <Button className={styles.recomendedng_catalog_card_btn} variant="primary">
                              <Spinner style={{ width: `20px`, height: `20px` }} animation="border" variant="light" />
                            </Button>
                          :
                            <Button onClick={() => showInCart( elm.id )} className={styles.recomendedng_catalog_card_btn} variant={ this.inCart( elm.res_id ) ? `danger` : `primary`}>
                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.9129 15.4305C13.8035 15.4305 12.9042 16.3299 12.9042 17.4393C12.9042 18.5487 13.8035 19.448 14.9129 19.448C16.0223 19.448 16.9217 18.5487 16.9217 17.4393C16.9217 16.3299 16.0223 15.4305 14.9129 15.4305ZM14.9129 15.4305H7.17309C6.71001 15.4305 6.47805 15.4305 6.28739 15.3481C6.11921 15.2754 5.9733 15.1584 5.86699 15.0092C5.74783 14.8419 5.69991 14.6183 5.60505 14.1755L3.133 2.63933C3.03593 2.18634 2.98675 1.9601 2.86621 1.7909C2.75991 1.64168 2.61402 1.52423 2.44584 1.45155C2.25514 1.36914 2.02447 1.36914 1.56119 1.36914H0.851562M3.86471 4.38229H16.7944C17.5193 4.38229 17.8814 4.38229 18.1247 4.53331C18.3378 4.66559 18.4939 4.87305 18.5619 5.11449C18.6396 5.39012 18.5398 5.73817 18.3389 6.4347L16.9482 11.2557C16.828 11.6722 16.7679 11.88 16.6461 12.0346C16.5385 12.171 16.3966 12.2777 16.2357 12.3433C16.054 12.4174 15.8381 12.4174 15.4072 12.4174H5.60276M5.87348 19.448C4.76407 19.448 3.86471 18.5487 3.86471 17.4393C3.86471 16.3299 4.76407 15.4305 5.87348 15.4305C6.98289 15.4305 7.88224 16.3299 7.88224 17.4393C7.88224 18.5487 6.98289 19.448 5.87348 19.448Z" stroke="white" strokeWidth="0.964208" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                            </Button>
                          }
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </SwiperSlide>
              )
            })}
            <SwiperSlide className={styles.recomendedng_catalog_card_w_last}></SwiperSlide>
          </Swiper>
        </Container>
      </div>
    )
  }
}

Main.propTypes = {
  title: PropTypes.string,
  products: PropTypes.array,
  showInCart: PropTypes.func,
  in_cart_loading: PropTypes.bool,
  favorite: PropTypes.array,
  changeFavorite: PropTypes.func,
  cart: PropTypes.array,
  link: PropTypes.string
}